module.exports = __webpack_public_path__ + "static/jason-barnwell-c7776a71b9f082f5c6900ec66ec43f70.png";